<button class="mb-4 p-0 bg-transparent border-0 fs-md-18 d-print-none" [ngClass]="areSourcesVisible ? 'text-blue' : 'text-green'" (click)="toggleSources()">
    View Sources & References <i [ngClass]="[areSourcesVisible ? 'icon-gard-drop-arrow-up' : 'icon-gard-drop-arrow-down']"></i>
</button>

<h2 class="d-none d-print-block">Sources &amp; References</h2>
<div class="sources d-flex justify-content-end text-link">
    <div class="article mb-5 fs-md-18 d-print-block" embeddedHTML [innerHtml]="article.bodyText" [hidden]="!areSourcesVisible" [attr.aria-expanded]="areSourcesVisible"></div>
</div>
